import { ProductFooterProps } from './types';

const getCopyrightText = (productCode: ProductFooterProps['productCode']) => {
  const copyrightYear = new Date().getUTCFullYear().toString();

  // FIXME: We may want to update these defaults to © Signum International AG {year}. All rights reserved.
  switch (productCode) {
    case 'COUS':
    case 'CST':
    case 'EAUS':
    case 'ETUS':
      return [`© Signum International AG ${copyrightYear}. All rights reserved.`];
    case 'ETCA':
      return [
        `© ${copyrightYear} Signum International AG`,
        `Registration Numbers: TICO-2395858 | CPBC-73991 | OPC-702732`,
      ];
    case 'ETFC':
      return [
        `© ${copyrightYear} Signum International AG`,
        `Numéros d'enregistrement : TICO-2395858 | CPBC-73991 | OPC-702732`,
      ];
    default:
      throw new Error(`Unknown product code supplied to footer component: "${productCode}"`);
  }
};

const getLegalNotices = (productCode: ProductFooterProps['productCode']) => {
  const text = 'Legal Notices';

  switch (productCode) {
    case 'COUS':
      return { text, href: '//www.efultimatebreak.com/faq/booking-conditions#terms' };
    case 'CST':
    case 'EFSA':
      return { text, href: '//www.efstudyabroad.com/legal/legal-notices' };
    case 'EAUS':
      return { text, href: '//www.efexploreamerica.com/legal/legal-notices' };
    case 'ETUS':
      return { text, href: '//www.eftours.com/legal/legal-notices' };
    case 'ETCA':
      return { text, href: '//www.eftours.ca/legal/legal-notices' };
    case 'ETFC':
      return { text: 'Avis juridiques', href: '//www.efvoyages.ca/legal/legal-notices' };
    default:
      throw new Error(`Unknown product code supplied to footer component: "${productCode}"`);
  }
};

export { getCopyrightText, getLegalNotices };
